import { render } from "./Loader.vue?vue&type=template&id=5373c290"
const script = {}

import exportComponent from "/__w/yja-liferay-73/yja-liferay-73/modules/yja-assessment-survey/yja-assessment-survey-vue/public-view/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__